import React from "react";
import { CustomColorUtils } from "utilities/custom-color-utils";
import { UserBookmarkColors } from "utilities/enumerations/user-bookmark-colors";
import StringUtils from "utilities/string-utils";
const CSS_CLASS_NAME = "c-avatar";
const Avatar = ({
    name,
    colorHashBasedOn,
}: {
    name: string;
    colorHashBasedOn?: string;
}) => {
    const firstInitial = name?.substring(0, 1).toUpperCase();

    // Avatar (for owner and individual user saves)
    const colorValue =
        StringUtils.getRandomNumberBasedOnString(colorHashBasedOn ?? name, 8) +
        1; // hash is 0 based, enum is 1 based
    const colorToUseIfIndividual = CustomColorUtils.getClassModifier(
        UserBookmarkColors,
        colorValue,
        "bookmark"
    );
    return (
        <div
            role="presentation"
            className={`${CSS_CLASS_NAME} ${colorToUseIfIndividual}`}>
            {firstInitial}
        </div>
    );
};

export default Avatar;
